import { ca } from '@cian/analytics';

export function trackOpenFaqModalClick(faqBlockName: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DealSaleCcPromo',
    action: 'Click_sopr',
    label: `FAQ/${faqBlockName}`,
  });

  return faqBlockName;
}
